export const SupportStatus = {
    WaitingForCyberfusion: 'waiting_for_cyberfusion',
    WaitingForUser: 'waiting_for_user',
    Closed: 'closed',
};
